import { render, staticRenderFns } from "./game-form.vue?vue&type=template&id=1c228a80&"
import script from "./game-form.vue?vue&type=script&lang=js&"
export * from "./game-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports